import { useEffect } from 'react';

const useSessionTimeout = () => {
  useEffect(() => {
    const handleActivity = () => {
      sessionStorage.setItem('lastActivity', Date.now().toString());
    };

    // Eventos de interacción
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('click', handleActivity);

    // Limpieza de eventos
    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('click', handleActivity);
    };
  }, []);
};

export default useSessionTimeout;
